import { Fragment } from "react";
//import Birds from "../components/Birds";
import Icons from "../components/Icons";
import Stocks from "../components/Stocks";
import SubjectLineApp from "../components/SubjectLineApp";
import URLDataOverlay from "../components/URLDataOverlay";
import MarketingDataCycleSimulator from "../components/MarketingDataCycleSimulator";
const CurrentProjects = () => {
  return (
    <Fragment>
      <h2>Marketing Data Cycle Simulator (Work in Progress)</h2>
      <MarketingDataCycleSimulator />
      <hr className="my-12 border-t border-slate-200" />

      <h2>Email Subject Line Generator (AI Demo)</h2>

      <SubjectLineApp />

      <hr className="my-12 border-t border-slate-200" />

      <h2>URL Data Overlay Bookmarklet</h2>

      <URLDataOverlay />
      <hr className="my-12 border-t border-slate-200" />

      <h2>Nature Icons</h2>
      <p className="mb-4">
        I plan to share some SVG icons here. More to come.{" "}
      </p>

      <Icons />
      <hr className="my-12 border-t border-slate-200" />
      <h2>Data Visualizations (D3)</h2>
      <Stocks />
    </Fragment>
  );
};

export default CurrentProjects;
